module.exports = __webpack_public_path__ + "img/img-2.af0616c6.jpg";